import { useState } from "react";

export type DataAdd<Res, AddParams extends unknown[] = unknown[]> = (
  ...args: AddParams
) => Promise<Res>;

type UseAddRes<Res, AddParams extends unknown[] = unknown[]> = {
  loading: boolean;
  add: DataAdd<Res, AddParams>
};

const useDataAdd = <AddParams extends unknown[], Res extends { id: string }>({
  api,
}: {
  api: DataAdd<Res, AddParams>;
}): UseAddRes<Res, AddParams> => {
  const [loading, setLoading] = useState<boolean>(false);

  const add: DataAdd<Res, AddParams> = (...args: AddParams) => {
    setLoading(true);
    return new Promise<Res>((resolve, reject) => {
      api(...args)
        .then((res) => resolve(res))
        .catch((error) => {
          setLoading(false)
          return reject(error);
        })
        .finally(() => setLoading(false));
    });
  };

  return { loading, add };
};

export default useDataAdd;
